import React, { useEffect } from "react";

import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
  FaGem,
  FaLink,
  FaCoins,
  FaCubes,
  FaLock,
} from "react-icons/fa";

import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import testingIcon from "../assets/reviews/icons/1.png";
import paymentIcon from "../assets/reviews/icons/2.png";
import ratesIcon from "../assets/reviews/icons/3.png";
import trustIcon from "../assets/reviews/icons/4.png";
// import Testimonials from "../components/Testimonials";
import ReusableLandingSections from "../components/landingSections/ReusableLandingSections";
import RajajinagarContentSections from "../components/landingSections/RajajinagarContentSections";

const whatWeBuyIcons = [FaGem, FaLink, FaCoins, FaCubes, FaLock];
const goldGradient = {
  background: "linear-gradient(135deg, #C89B2B 0%, #F2D36A 100%)",
};

const primaryButtonStyle = {
  background: "linear-gradient(135deg, #EFCB57 0%, #C89B2B 100%)",
};


const createMobileHeroDescription = (
  html = "",
  maxWords = 24,
  extraWords = 8
) => {
  const text = String(html)
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\s+/g, " ")
    .trim();

  if (!text) return "";

  const words = text.split(" ");

  // Short content: show normally
  if (words.length <= maxWords) {
    return text;
  }

  const normalLimit = words.slice(0, maxWords).join(" ");

  // Look a few words ahead for natural punctuation
  const extendedLimit = words
    .slice(0, maxWords + extraWords)
    .join(" ");

  const remainingPart = extendedLimit.slice(normalLimit.length);

  // Find nearest comma / full stop / question mark / exclamation
  const punctuationMatch = remainingPart.match(/^[\s\S]*?[,\.!?]/);

  if (punctuationMatch) {
    return `${normalLimit}${punctuationMatch[0]}`.trim();
  }

  // If there is already a complete sentence before 24 words,
  // stop at that sentence instead of showing "..."
  const lastFullStop = Math.max(
    normalLimit.lastIndexOf("."),
    normalLimit.lastIndexOf("!"),
    normalLimit.lastIndexOf("?")
  );

  if (lastFullStop > normalLimit.length * 0.5) {
    return normalLimit.slice(0, lastFullStop + 1).trim();
  }

  // Final fallback: no dots
  return normalLimit.trim();
};

const BranchDetailPage = ({ branch }) => {
  const location = useLocation();



 


  // const showGoldValueCta = isMalleshwaramPage || isBangalorePage;
  const currentPath = location.pathname.replace(/^\/+|\/+$/g, "");

  const currentSlug =
  location.pathname.split("/").filter(Boolean).pop() || "";

  const mobileHeroDescriptions = {
  "sell-gold-in-bangalore":
    "Sell gold in Bangalore with transparent purity testing, accurate weight checking, live gold rate valuation, and quick payment.",

  "gold-buyers-in-bangalore":
    "Choose trusted gold buyers in Bangalore for transparent testing, accurate weight, clear valuation, and quick payment.",

  "pledged-gold-buyers-in-bangalore":
    "Get help with pledged gold in Bangalore through a clear release, valuation, and payment process.",

  "release-pledged-gold-in-bangalore":
    "Release pledged gold in Bangalore with simple support, transparent valuation, and quick payment after approval.",
};

const mobileHeroDescription =
  mobileHeroDescriptions[currentSlug] ||
  createMobileHeroDescription(branch?.bannerDescription);


  
  const isReleasePledgedGoldLocationPage =
  currentPath.startsWith("release-pledged-gold-in-");

const isMalleshwaramPage = currentPath === "sell-gold-in-malleshwaram";
const isBangalorePage =
  currentPath === "sell-gold-in-bangalore" ||
  currentPath === "gold-buyers-in-bangalore";
  const isGoldBuyersBangalorePage =
  currentPath === "gold-buyers-in-bangalore";
  const isYelahankaPage =
  currentPath === "sell-gold-in-yelahanka";
const isRajajinagarPage = currentPath === "sell-gold-in-rajajinagar";
const isSeshadripuramPage = currentPath === "sell-gold-in-seshadripuram";
const isGuttahalliPage = currentPath === "sell-gold-in-guttahalli";
const isMathikerePage = currentPath === "sell-gold-in-mathikere";
const isYeshwanthpurPage = currentPath === "sell-gold-in-yeshwanthpur";
const isHebbalPage = currentPath === "sell-gold-in-hebbal";
const isRTNagarPage = currentPath === "sell-gold-in-rt-nagar";
const isSanjaynagarPage = currentPath === "sell-gold-in-sanjaynagar";
const isVijayanagarPage = currentPath === "sell-gold-in-vijayanagar";
const isSadashivaNagarPage = currentPath === "sell-gold-in-sadashiva-nagar";
const isVyalikavalPage = currentPath === "sell-gold-in-vyalikaval";
const isMajesticPage = currentPath === "sell-gold-in-majestic";
const isBasaveshwaraNagarPage =
  currentPath === "sell-gold-in-basaveshwara-nagar";

const isMalleshwaramStylePage =
  branch?.useMalleshwaramStyle === true ||
  isMalleshwaramPage ||
  isSeshadripuramPage ||
  isGuttahalliPage ||
  isBasaveshwaraNagarPage ||
  isMathikerePage ||
  isYeshwanthpurPage ||
  isHebbalPage ||
  isRTNagarPage ||
  isSanjaynagarPage ||
  isVijayanagarPage ||
  isSadashivaNagarPage ||
  isVyalikavalPage ||
  isMajesticPage;



const hideSections = branch?.hideSections || {};

const showGoldValueCta =
  isMalleshwaramPage || isBangalorePage || isSeshadripuramPage;

const malleshwaramMapLink =
  "https://www.google.com/maps?ll=13.004009,77.570236&z=17&t=m&hl=en-GB&gl=US&mapclient=embed&cid=1831824540858012813";

const bangaloreMapLink =
  "https://www.google.com/maps/search/?api=1&query=G1+Gold+Bangalore";

const goldValueCtaDirectionsLink =
  branch?.mapLink ||
  (isMalleshwaramPage ? malleshwaramMapLink : bangaloreMapLink);

const goldValueCtaLocationText =
  branch?.area || branch?.city || "Bangalore";
  


 const scrollToGoldValueContact = () => {
  document
    .getElementById("gold-value-contact-section")
    ?.scrollIntoView({ behavior: "smooth", block: "start" });
};



  
  const processIcons = [
  (
    <svg viewBox="0 0 24 24" className="h-12 w-12" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 10h16" />
      <path d="M5 10l1-4h12l1 4" />
      <path d="M6 10v9h12v-9" />
      <path d="M9 19v-5h6v5" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" className="h-12 w-12" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <path d="M8 8h8" />
      <path d="M8 12h8" />
      <path d="M8 16h5" />
      <circle cx="17" cy="17" r="2" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" className="h-12 w-12" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 16h12" />
      <path d="M8 16V8h8v8" />
      <path d="M10 8V5h4v3" />
      <path d="M9 12h6" />
      <circle cx="9" cy="19" r="1" />
      <circle cx="15" cy="19" r="1" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" className="h-12 w-12" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 3h7l5 5v13H7z" />
      <path d="M14 3v5h5" />
      <path d="M9 13h6" />
      <path d="M9 17h4" />
      <circle cx="16" cy="16" r="3" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" className="h-12 w-12" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 14h4l3 4h6l3-5" />
      <path d="M7 14V7h10v6" />
      <path d="M10 10h4" />
      <path d="M12 8v4" />
    </svg>
  ),
];
const advantageContent = isBangalorePage
  ? {
      eyebrow:
        branch?.advantageEyebrow ||
        "The Bangalore Gold Selling Advantage",

      title:
        branch?.advantageTitle ||
        "Sell Gold in Bangalore With Clear Value Confidence",

      description:
        branch?.advantageDescription ||
        "Before selling your gold, know how the value is checked, calculated, and paid. G1 Gold makes the gold selling process in Bangalore simple, transparent, and customer-friendly.",

      leftHeader:
        branch?.advantageLeftHeader ||
        "What Customers Look For",

      middleHeader:
        branch?.advantageMiddleHeader ||
        "Common Gold Selling Issues",

      rightHeader:
        branch?.advantageRightHeader ||
        "G1 Gold Bangalore Advantage",

   
  rows: branch?.advantageRows || [
        {
          want: "Gold Value Clarity",
          other: "Price calculation may not be explained properly",
          promise: "Purity, weight, and live gold rate are clearly explained",
        },
        {
          want: "Purity Checking",
          other: "Basic testing without proper value explanation",
          promise: "Accurate gold purity checking before final valuation",
        },
        {
          want: "Weight Verification",
          other: "Weight details may not be clearly shown",
          promise: "Exact gold weight checking with complete clarity",
        },
        {
          want: "Live Gold Rate",
          other: "Some buyers may use unclear or old rate references",
          promise: "Gold value is calculated using current live market rate",
        },
        {
          want: "Payment Speed",
          other: "Payment may take time after agreement",
          promise: "Quick payment after customer approval",
        },
        {
          want: "Old Gold Acceptance",
          other: "Some buyers may avoid broken or old gold items",
          promise: "Old jewellery, coins, bars, and broken gold are accepted",
        },
        {
          want: "Customer Comfort",
          other: "Process may feel confusing for first-time sellers",
          promise: "Simple step-by-step guidance from our team",
        },
        {
          want: "Local Service",
          other: "Customers may need to search multiple buyers",
          promise: "Trusted gold buyers in Bangalore with easy visit support",
        },
      ],
    }
: {
    eyebrow: branch?.advantageEyebrow || "The G1 Gold Advantage",
    title: branch?.advantageTitle || "Better Service, With Clear Difference",
    description:
      branch?.advantageDescription ||
      `Compare G1 Gold ${branch?.area || "Malleshwaram"} with other <a href="https://g1gold.com/" style="color: inherit; text-decoration: none; font-weight: 700;">gold buyers</a> in ${branch?.area || "Malleshwaram"} and see the clear difference. From transparent gold valuation and live gold rate pricing to accurate purity testing and quick payment, this section helps customers understand why G1 Gold is a trusted place to sell gold in ${branch?.area || "Malleshwaram"}.`,
    leftHeader: branch?.advantageLeftHeader || "What Customers Want",
    middleHeader: branch?.advantageMiddleHeader || "Most Other Buyers",
    rightHeader: branch?.advantageRightHeader || "G1 Gold Promise",
    rows: branch?.advantageRows || [
      {
        want: "Trust & Transparency",
        other: "Process not fully explained",
        promise: "100% transparent testing in front of you",
      },
      {
        want: "Accurate Valuation",
        other: "Weight or purity not clearly shown",
        promise: "Accurate weight, purity & live gold rate",
      },
      {
        want: "Fair Price",
        other: "Hidden charges or unexplained deductions",
        promise: "No hidden charges, all deductions explained",
      },
      {
        want: "Instant Payment",
        other: "Payment may take time",
        promise: "Instant payment through cash/UPI/NEFT",
      },
      {
        want: "Simple Process",
        other: "Complicated documentation and lengthy process",
        promise: "Simple KYC, quick and hassle-free process",
      },
      {
        want: "Customer Support",
        other: "Limited support after transaction",
        promise: "Dedicated support before, during & after the sale",
      },
    ],
  };
       
    const advantageIcons = [
  <path d="M12 3l7 3v5c0 4.5-2.8 8.4-7 10-4.2-1.6-7-5.5-7-10V6l7-3Z" />,

  <>
    <path d="M12 3v18" />
    <path d="M6 7h12" />
    <path d="M7 7l-3 6h6L7 7Z" />
    <path d="M17 7l-3 6h6l-3-6Z" />
  </>,

  <>
    <path d="M20 12V6a2 2 0 0 0-2-2h-6L4 12l8 8 8-8Z" />
    <circle cx="15" cy="9" r="1" />
  </>,

  <path d="M13 2L5 14h6l-1 8 9-13h-6l1-7Z" />,

  <>
    <path d="M7 3h7l5 5v13H7z" />
    <path d="M14 3v5h5" />
    <path d="M9 13h6" />
    <path d="M9 17h4" />
  </>,

  <>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21c1.8-4 14.2-4 16 0" />
  </>,

  <>
    <circle cx="12" cy="12" r="8" />
    <path d="M9 12l2 2 4-4" />
  </>,

  <>
    <path d="M12 21s-6-5.2-6-10a6 6 0 1 1 12 0c0 4.8-6 10-6 10z" />
    <circle cx="12" cy="11" r="2.5" />
  </>,
];
const seoTitle =
  branch?.metaTitle ||
  branch?.twitterTitle ||
  branch?.bannerTitle ||
  branch?.title ||
  "G1 Gold | Trusted Gold Buyers";

const seoDescription =
  branch?.metaDescription ||
  branch?.twitterDescription ||
  branch?.bannerDescription ||
  "Sell gold at G1 Gold with transparent purity testing, fair valuation and quick payment.";

const canonicalUrl =
  branch?.canonical ||
  branch?.twitterUrl ||
  `https://g1gold.com/${currentPath}`;

const seoImageRaw =
  branch?.ogImage ||
  branch?.twitterImage ||
  branch?.bannerImage ||
  branch?.mainImage ||
  "/logo512.png";

const seoImage = seoImageRaw.startsWith("http")
  ? seoImageRaw
  : `https://g1gold.com${seoImageRaw.startsWith("/") ? seoImageRaw : `/${seoImageRaw}`}`;

useEffect(() => {
  if (!branch) return;

  document.title = seoTitle;

  const setMeta = (attr, key, content) => {
    if (!content) return;

    let tag = document.head.querySelector(`meta[${attr}="${key}"]`);

    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute(attr, key);
      document.head.appendChild(tag);
    }

    tag.setAttribute("content", content);
  };

  const setCanonical = (href) => {
    if (!href) return;

    let link = document.head.querySelector('link[rel="canonical"]');

    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }

    link.setAttribute("href", href);
  };

  setMeta("name", "description", seoDescription);
  setMeta("name", "robots", "index, follow");

  setMeta("property", "og:title", seoTitle);
  setMeta("property", "og:description", seoDescription);
  setMeta("property", "og:url", canonicalUrl);
  setMeta("property", "og:image", seoImage);
  setMeta("property", "og:type", "website");

  setMeta("name", "twitter:card", branch?.twitterCard || "summary_large_image");
  setMeta("name", "twitter:title", seoTitle);
  setMeta("name", "twitter:description", seoDescription);
  setMeta("name", "twitter:image", seoImage);

  setCanonical(canonicalUrl);
}, [branch, seoTitle, seoDescription, canonicalUrl, seoImage]);

  if (!branch) return null;

  return (
    <div className="min-h-screen bg-white">
<Helmet defer={false}>
  <html lang="en" />

  <title>{seoTitle}</title>
 <meta name="description" content={seoDescription} />
  <meta name="robots" content="index, follow" />

  <link rel="canonical" href={canonicalUrl} />


  <meta property="og:type" content="website" />


  <script type="application/ld+json">
  {JSON.stringify({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://g1gold.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
  name:
  branch?.title ||
  (isMalleshwaramPage
    ? "Sell Gold in Malleshwaram"
    : "Sell Gold"),
        item: canonicalUrl,
      },
    ],
  })}
</script>
{branch?.faqs?.length > 0 && (
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: branch.faqs.map((faq) => ({
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq.answer,
        },
      })),
    })}
  </script>
)}
</Helmet>
      <Header />

      <main>
{/* HERO */}
<section className="relative overflow-hidden bg-[#081225]">
  {/* Clean premium hero background - no repeated/watermark lady image */}
  <div className="pointer-events-none absolute inset-0">
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_18%_22%,rgba(244,209,107,0.18),transparent_32%),radial-gradient(circle_at_78%_24%,rgba(216,169,31,0.14),transparent_30%),linear-gradient(135deg,#081225_0%,#0b1730_45%,#121826_100%)]" />
    <div className="absolute inset-0 opacity-[0.14] bg-[linear-gradient(rgba(244,209,107,0.12)_1px,transparent_1px),linear-gradient(90deg,rgba(244,209,107,0.10)_1px,transparent_1px)] [background-size:54px_54px]" />
    <div className="absolute left-[-180px] top-[-160px] h-[420px] w-[420px] rounded-full bg-[#f4d16b]/12 blur-3xl" />
    <div className="absolute bottom-[-220px] right-[16%] h-[520px] w-[520px] rounded-full bg-[#c89b2b]/10 blur-3xl" />
    <div className="absolute right-[7%] top-[14%] hidden h-28 w-28 rounded-full border border-[#f4d16b]/20 lg:block" />
    <div className="absolute right-[11%] top-[20%] hidden h-12 w-12 rounded-full bg-[#f4d16b]/10 lg:block" />
  </div>

  <div className="relative mx-auto max-w-[1600px] px-6 py-12 lg:px-14 lg:py-20">
    <div className="grid items-center gap-10 lg:grid-cols-[1.08fr_0.92fr]">
      {/* Left Content */}
      <div className="max-w-3xl">
        <span className="inline-flex items-center rounded-full border border-[#c89b2b]/35 bg-[#c89b2b]/12 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-[#f4d16b]">
          {branch.badge || "Affiliated with Indian Gold Buyers"}
        </span>

        <h1 className="mt-5 text-[32px] font-bold leading-[1.06] text-white sm:text-[40px] lg:text-[56px]">
          {branch.bannerTitle}
        </h1>

    {mobileHeroDescription ? (
  <>
    {/* Short content - MOBILE ONLY */}
    <p
      className="mt-4 max-w-2xl text-[14px] leading-6 text-white/85 sm:hidden"
      dangerouslySetInnerHTML={{
        __html: mobileHeroDescription,
      }}
    />

    {/* Existing full content - TABLET / DESKTOP */}
    <p
      className="mt-5 hidden max-w-2xl text-[15px] leading-8 text-white/85 sm:block sm:text-base"
      dangerouslySetInnerHTML={{
        __html: branch.bannerDescription,
      }}
    />
  </>
) : (
  /* All other slugs stay exactly as before */
  <p
    className="mt-5 max-w-2xl text-[15px] leading-8 text-white/85 sm:text-base"
    dangerouslySetInnerHTML={{
      __html: branch.bannerDescription,
    }}
  />
)}

        {/* Trust Points */}
        <div className="mt-8 flex w-full flex-wrap items-center justify-start gap-x-8 gap-y-4 text-[17px] font-medium text-white sm:text-[18px]">
          {[
            "Live market rates",
            "Instant payment",
            "Transparent process",
          ].map((item, index) => (
            <div key={index} className="flex items-center gap-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 flex-shrink-0 text-[#f4d16b]"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 6L9 17l-5-5" />
              </svg>

              <span className="whitespace-nowrap">{item}</span>
            </div>
          ))}
        </div>

    {/* Buttons - Below Trust Points */}
{/* Buttons - Below Trust Points */}
<div className="mt-8 w-full max-w-[620px] rounded-[22px] border border-white/10 bg-white/[0.08] p-2.5 shadow-[0_16px_38px_rgba(0,0,0,0.24)] backdrop-blur-md">
  <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
   <button
  type="button"
onClick={scrollToGoldValueContact}
  className="group relative inline-flex min-h-[58px] flex-1 items-center justify-center overflow-hidden rounded-[14px] px-7 py-3 text-center text-[17px] font-bold text-[#071225] shadow-[0_12px_26px_rgba(239,203,87,0.28)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_16px_34px_rgba(239,203,87,0.42)]"
  style={{
    background: "linear-gradient(135deg, #F7DB69 0%, #D8A91F 100%)",
  }}
>
  <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/35 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
  <span className="relative">Sell Gold Now</span>
</button>
<Link
  to="https://g1gold.com/release-pledged-gold"
  className="group relative inline-flex min-h-[58px] flex-1 items-center justify-center overflow-hidden rounded-[14px] border border-[#d7a51f] bg-white/[0.08] px-7 py-3 text-center text-[17px] font-bold text-[#fff7df] shadow-[0_12px_26px_rgba(0,0,0,0.18)] backdrop-blur-sm transition-all duration-300 hover:-translate-y-0.5 hover:border-[#f4d16b] hover:bg-white/[0.12] hover:shadow-[0_16px_34px_rgba(0,0,0,0.28)]"
>
  <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-[#f4d16b]/20 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
  <span className="relative">Release Pledged Gold</span>
</Link>
  </div>
</div>
      </div>

      {/* Right Image */}
      <div className="lg:pl-4">
        <div className="overflow-hidden rounded-[30px] border border-white/10 bg-white/5 shadow-[0_24px_60px_rgba(0,0,0,0.28)]">
<img
  src={branch.mainImage}
  alt={branch.mainImageAlt || branch.title}
  className={`h-[340px] w-full object-cover sm:h-[420px] lg:h-[560px] ${
    isRajajinagarPage
      ? "scale-110 object-[center_18%]"
      : "object-[center_20%]"
  }`}
/>

        </div>
          </div>
    </div>
  </div>

</section>


{/* INTRO / STORY */}
<section className="bg-white pt-6 pb-8 sm:pt-8 sm:pb-10 lg:pt-10 lg:pb-10">
  <div className="mx-auto grid max-w-[1600px] items-center gap-5 px-4 sm:gap-6 sm:px-6 lg:grid-cols-[0.9fr_1.1fr] lg:gap-8 lg:px-14">
    
    {/* LEFT IMAGE - desktop left, mobile second */}
    <div className="order-2 h-[clamp(220px,65vw,320px)] overflow-hidden rounded-[18px] border border-[#f1e7c8] bg-white shadow-sm sm:h-[380px] sm:rounded-[24px] lg:order-1 lg:h-[440px]">
      <img
        src={branch.introImage || branch.mainImage}
        alt={branch.introImageAlt || `${branch.title} overview`}
        className="block h-full w-full object-cover object-[center_18%]"
      />
    </div>

    {/* RIGHT CONTENT - desktop right, mobile first */}
    <div className="relative order-1 flex min-h-[300px] overflow-hidden rounded-[20px] border border-[#f1e2b8] bg-gradient-to-br from-[#fffdf7] via-white to-[#fff7df] px-4 py-6 shadow-[0_18px_45px_rgba(20,33,61,0.07)] sm:min-h-[360px] sm:rounded-[28px] sm:px-6 sm:py-7 lg:order-2 lg:h-[440px] lg:min-h-0 lg:px-8 lg:py-8">
      <div className="absolute right-[-80px] top-[-80px] h-44 w-44 rounded-full bg-[#f4d16b]/20 blur-3xl" />
      <div className="absolute bottom-[-90px] left-[-90px] h-48 w-48 rounded-full bg-[#c89b2b]/10 blur-3xl" />

      <div className="relative flex w-full flex-col items-start justify-center text-left">
        <p className="inline-flex w-fit rounded-full border border-[#d7a51f]/30 bg-[#fff4cf] px-3 py-1.5 text-[9px] font-semibold uppercase tracking-[0.16em] text-[#b68b22] sm:px-3.5 sm:text-[11px] sm:tracking-[0.2em]">
          Trusted Gold Buyers
        </p>

        <h2 className="mt-4 max-w-3xl text-[clamp(24px,7vw,30px)] font-semibold leading-[1.15] text-[#14213d] md:text-[34px] lg:text-[40px]">
          {branch.introTitle}
        </h2>

        <p
          className="mt-3 max-w-3xl text-[14px] leading-6 text-[#334155] sm:mt-4 sm:text-[15px] sm:leading-7 md:text-[16px]"
          dangerouslySetInnerHTML={{ __html: branch.introDescription }}
        />

        <div className="mt-5 h-[3px] w-20 rounded-full bg-gradient-to-r from-[#C89B2B] to-[#F2D36A] sm:w-24" />
      </div>
    </div>

  </div>
</section>

{/* WHAT WE BUY - ONLY MALLESHWARAM PAGE */}
{isMalleshwaramStylePage && (
  <section className="relative overflow-hidden bg-[#fffaf0] py-9 sm:py-14 lg:py-16">
    {/* premium background */}
    <div className="pointer-events-none absolute left-[-260px] top-[-240px] h-[560px] w-[560px] rounded-full bg-[#f4d16b]/20 blur-3xl" />
    <div className="pointer-events-none absolute right-[-260px] bottom-[-260px] h-[580px] w-[580px] rounded-full bg-[#c89b2b]/12 blur-3xl" />
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(244,209,107,0.14),transparent_32%),radial-gradient(circle_at_bottom_right,rgba(200,155,43,0.10),transparent_34%)]" />

    <div className="relative mx-auto max-w-[1420px] px-4 sm:px-6 lg:px-10">
      {/* TOP CONTENT */}
      <div className="mx-auto max-w-5xl text-center">
        <p className="text-[9px] font-extrabold uppercase tracking-[0.28em] text-[#b68b22] sm:text-[10px] sm:tracking-[0.42em]">
          What We Buy
        </p>

        <h2 className="mx-auto mt-3 max-w-[900px] text-[clamp(26px,7vw,34px)] font-extrabold leading-tight tracking-[-0.03em] text-[#06152f] sm:text-[40px] lg:text-[48px]">
          Gold Items You Can Sell at G1 Gold
        </h2>

        <div className="mx-auto mt-4 flex w-[120px] items-center justify-center gap-3 sm:mt-5 sm:w-[150px]">
          <span className="h-px flex-1 bg-[#d7a51f]" />
          <span className="h-2 w-2 rotate-45 bg-[#d7a51f]" />
          <span className="h-px flex-1 bg-[#d7a51f]" />
        </div>
      </div>

      {/* MAIN DESIGN */}
      <div className="mx-auto mt-7 grid w-full max-w-[1220px] items-stretch gap-5 sm:mt-8 lg:grid-cols-[0.98fr_1fr] lg:gap-6">
        {/* LEFT BIG IMAGE */}
        <div className="relative h-[clamp(390px,105vw,470px)] overflow-hidden rounded-[18px] border border-[#c99a24]/80 bg-[#06152f] shadow-[0_22px_60px_rgba(20,33,61,0.16)] sm:h-[390px] sm:rounded-[22px] lg:h-full lg:min-h-[470px]">
          <img
         src={`${process.env.PUBLIC_URL}${branch.whatWeBuyImage || "/images/how-it-works/malleshwaram-what-we-buy.png"}`}
            alt="Gold jewellery items accepted for sale at G1 Gold valuation centre"
            className="h-full w-full object-cover object-center"
            loading="lazy"
          onError={(e) => {
  e.currentTarget.onerror = null;
  e.currentTarget.src = `${process.env.PUBLIC_URL}/images/how-it-works/malleshwaram-what-we-buy.png`;
}}
          />

          <div className="absolute inset-0 bg-gradient-to-t from-[#06152f]/65 via-transparent to-transparent" />

         
        </div>

        {/* RIGHT CARDS */}
        <div className="grid h-full min-w-0 gap-3 sm:grid-cols-2 sm:gap-4 lg:grid-rows-3 lg:gap-5">
         {(branch.whatWeBuyItems || [
            {
              title: "Old & Used Gold Jewellery",
              text: "Sell old jewellery and unused ornaments with best value.",
              image: "/images/how-it-works/old-used-gold.png",
              fallbackIcon: FaGem,
            },
            {
              title: "Broken or Damaged Gold",
              text: "Broken or damaged gold still has value. We buy it.",
              image: "/images/how-it-works/broken-gold.png",
              fallbackIcon: FaLink,
            },
            {
              title: "Gold Coins & Bullion",
              text: "We buy all types of gold coins and bullion.",
              image: "/images/how-it-works/gold-coins.png",
              fallbackIcon: FaCoins,
            },
            {
              title: "Gold Bars",
              text: "Get accurate valuation for gold bars of different sizes.",
              image: "/images/how-it-works/gold-bars.png",
              fallbackIcon: FaCubes,
            },
            {
              title: "Scrap or Unused Gold",
              text: "Turn your scrap or unused gold into instant cash.",
              image: "/images/how-it-works/scrap-gold.png",
              fallbackIcon: FaGem,
            },
            {
              title: "Pledged Gold",
              text: "We help you release your pledged gold and sell it.",
              image: "/images/how-it-works/pledged-gold.png",
              fallbackIcon: FaLock,
            },
         ]).map((item, index) => {
         const Icon = item.fallbackIcon || whatWeBuyIcons[index] || FaGem;

            return (
              <article
                key={index}
                className="group relative flex h-full min-h-[118px] min-w-0 items-center gap-3 overflow-hidden rounded-[15px] border border-[#e2c56f] bg-white/92 px-3.5 py-3.5 shadow-[0_12px_30px_rgba(20,33,61,0.06)] backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:border-[#d7a51f] hover:bg-white hover:shadow-[0_20px_42px_rgba(198,146,24,0.15)] sm:min-h-[145px] sm:gap-4 sm:rounded-[17px] sm:px-4 sm:py-4 lg:min-h-0"
              >
                <div className="relative flex h-[56px] w-[56px] shrink-0 items-center justify-center rounded-full bg-[#fff8df] shadow-[inset_0_0_0_6px_rgba(255,255,255,0.75)] sm:h-[72px] sm:w-[72px] sm:shadow-[inset_0_0_0_7px_rgba(255,255,255,0.75)]">
                  <img
                    src={`${process.env.PUBLIC_URL}${item.image}`}
                    alt={item.title}
                    className="h-[42px] w-[42px] object-contain drop-shadow-[0_8px_14px_rgba(120,72,0,0.14)] sm:h-[54px] sm:w-[54px]"
                    loading="lazy"
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                      const fallback = e.currentTarget.nextElementSibling;
                      if (fallback) fallback.style.display = "block";
                    }}
                  />

                  <Icon
                    className="hidden h-8 w-8 text-[#d7a51f] sm:h-9 sm:w-9"
                    aria-hidden="true"
                  />
                </div>

                <div className="relative min-w-0 flex-1">
                  <h3 className="max-w-full break-words text-[15px] font-extrabold leading-[1.15] text-[#06152f] sm:text-[18px]">
                    {item.title}
                  </h3>

                  <div className="mt-2 h-[2px] w-9 rounded-full bg-[#d7a51f] sm:mt-3 sm:w-11" />

                  <p className="mt-2 max-w-full text-[12px] font-medium leading-5 text-[#334155] sm:mt-2.5 sm:text-[12.5px]">
                    {item.text}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </div>
  </section>
)}
{/* WHAT WE BUY */}
{/* BANGALORE ONLY - TRANSPARENT GOLD VALUATION DESIGN */}
{/* YELAHANKA ONLY - TRANSPARENT VALUATION SECTION */}
{isYelahankaPage && (
  <section className="relative overflow-hidden bg-gradient-to-br from-[#fffaf0] via-[#fffdf8] to-[#f7edcf] py-8 sm:py-10 lg:py-14">

    {/* Background Glow */}
    <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-[#f4d16b]/20 blur-3xl" />
    <div className="pointer-events-none absolute -bottom-28 -right-24 h-80 w-80 rounded-full bg-[#c89b2b]/15 blur-3xl" />

    <div className="relative mx-auto max-w-[1280px] px-4 sm:px-6 lg:px-10">

      {/* Glass Container */}
      <div className="relative overflow-hidden rounded-[22px] border border-white/70 bg-white/55 p-4 shadow-[0_20px_60px_rgba(20,33,61,0.10)] backdrop-blur-xl sm:rounded-[28px] sm:p-6 lg:rounded-[32px] lg:p-8">

        <div className="grid items-center gap-6 lg:grid-cols-[1.05fr_0.95fr] lg:gap-10">

          {/* LEFT CONTENT */}
          <div className="relative order-1 px-1 py-2 sm:px-2 lg:px-4">

            {/* Small Accent */}
            <div className="mb-4 flex items-center gap-3">
              <span className="h-[2px] w-10 rounded-full bg-[#c89b2b] sm:w-14" />
              <span className="h-2 w-2 rotate-45 bg-[#d7a51f]" />
            </div>

            <h2 className="max-w-[700px] text-[25px] font-bold leading-[1.2] tracking-[-0.02em] text-[#06152f] sm:text-[31px] md:text-[35px] lg:text-[40px]">
              Sell Gold in Yelahanka With Transparent Valuation
            </h2>

            <p className="mt-5 max-w-[720px] text-[14px] leading-7 text-[#334155] sm:text-[15px] sm:leading-8 md:text-[16px] lg:text-[17px] lg:leading-8">
              If you want to{" "}
              <strong className="font-bold text-[#14213d]">
                sell gold in Yelahanka
              </strong>
              , start by making sure the buyer explains the valuation clearly
              before you agree to anything. Your gold should be checked for
              purity and weighed accurately in front of you, with stones or
              other non-gold parts handled separately where needed. The final
              amount should be based on the actual purity, eligible gold weight,
              and the applicable gold rate, with any deductions explained in
              advance. A transparent process gives you a clear idea of what your
              gold is worth and helps you make the decision with more confidence.
            </p>

          </div>

          {/* RIGHT IMAGE */}
          <div className="order-2">
            <div className="relative overflow-hidden rounded-[18px] border border-white/80 bg-white/40 shadow-[0_18px_45px_rgba(20,33,61,0.12)] backdrop-blur-md sm:rounded-[24px]">

              <div className="pointer-events-none absolute inset-0 z-10 bg-gradient-to-t from-[#06152f]/15 via-transparent to-white/5" />

              <img
                src="/images/branches/buyers-bangalore3.jpeg"
                alt="Transparent gold valuation in Yelahanka"
                className="h-[240px] w-full object-cover sm:h-[320px] md:h-[360px] lg:h-[390px]"
                loading="lazy"
              />

            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
)}
{isBangalorePage && (
  <section className="relative w-full overflow-hidden bg-white py-8 sm:py-10 lg:py-12">
    <div className="relative w-full px-4 sm:px-6 lg:px-8">
      <div className="w-full overflow-hidden rounded-[18px] border border-[#ead8a8]/80 bg-white px-5 py-8 shadow-[0_18px_50px_rgba(20,33,61,0.06)] sm:px-7 lg:px-12">
        <div className="grid w-full items-center gap-8 xl:grid-cols-[0.75fr_1.55fr] xl:gap-12">
          
          {/* LEFT CONTENT */}
          <div className="text-center xl:text-left">
          <h2 className="max-w-[520px] text-[24px] font-extrabold uppercase leading-tight tracking-[-0.02em] text-[#06152f] sm:text-[28px] lg:text-[34px]">
  {branch.valuationProcessTitle || "Transparent Gold Valuation Process"}
</h2>

<p
  className="mx-auto mt-2 max-w-[620px] text-[14px] font-medium leading-[1.55] text-[#334155] sm:text-[15px] xl:mx-0"
  dangerouslySetInnerHTML={{
    __html:
      branch.valuationProcessDescription ||
      "At G1 Gold, our 3-step gold valuation process checks purity, weight, and current gold rate pricing before the final value is explained.",
  }}
/>  </div>

          {/* RIGHT CARDS */}
          <div className="grid w-full gap-7 sm:grid-cols-2 xl:grid-cols-3">
          {(branch.valuationProcessCards || [
  {
    number: "1",
    title: "Accurate Purity Testing",
    text: "We check your gold purity carefully to understand the correct quality of your gold items.",
    image: "/images/how-it-works/malleshwaram-purity-testing.png",
  },
  {
    number: "2",
    title: "Exact Gold Weight Checking",
    text: "Your gold is weighed accurately before valuation, so the final value is calculated with complete clarity.",
    image: "/images/how-it-works/malleshwaram-weight-checking.png",
  },
  {
    number: "3",
    title: "Live Gold Rate Pricing",
    text: "Your gold value is calculated using the current live gold rate, helping you get the fair price you deserve.",
    image: "/images/how-it-works/malleshwaram-live-rate.png",
  },
]).map((item, index) => (
              <div
                key={index}
                className={`relative w-full ${
                  index === 2 ? "sm:col-span-2 xl:col-span-1" : ""
                }`}
              >
                {/* Number Circle */}
                <div className="absolute left-1/2 top-[-22px] z-20 flex h-11 w-11 -translate-x-1/2 items-center justify-center rounded-full bg-gradient-to-br from-[#f4c84f] to-[#c79211] text-[19px] font-bold text-white shadow-[0_10px_22px_rgba(198,146,24,0.35)]">
                  {item.number}
                </div>

                <div className="flex min-h-[285px] w-full flex-col items-center justify-start rounded-[16px] border border-[#ead8a8] bg-white px-6 pb-7 pt-12 text-center shadow-[0_12px_32px_rgba(20,33,61,0.05)] transition-all duration-300 hover:-translate-y-1 hover:border-[#d7a51f] hover:shadow-[0_18px_42px_rgba(198,146,24,0.12)]">
                  <div className="flex h-[100px] w-[120px] items-center justify-center">
                    <img
                      src={`${process.env.PUBLIC_URL}${item.image}`}
                      alt={item.title}
                      className="h-[96px] w-[110px] object-contain drop-shadow-[0_8px_14px_rgba(120,72,0,0.16)]"
                      loading="lazy"
                    />
                  </div>

                  <h3 className="mt-4 text-[19px] font-extrabold leading-snug text-[#06152f] sm:text-[20px] lg:text-[22px]">
                    {item.title}
                  </h3>

                  <p className="mt-4 max-w-[280px] text-[15px] font-medium leading-7 text-[#4b5563]">
                    {item.text}
                  </p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  </section>
)}
        

{/* PROCESS */}
{/* Malleshwaram Transparent Gold Valuation Process */}
{/* Malleshwaram Transparent Gold Valuation Process */}
{isMalleshwaramStylePage && (
  <section className="relative overflow-hidden bg-[#fffdf8] py-14 lg:py-16">
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(214,167,48,0.10),transparent_32%),radial-gradient(circle_at_bottom_right,rgba(214,167,48,0.08),transparent_34%)]" />

    <div className="relative mx-auto max-w-[1250px] px-5 sm:px-6 lg:px-10">
      {/* top ornament */}
      <div className="mx-auto flex max-w-[520px] items-center justify-center gap-4">
        <span className="h-[2px] flex-1 bg-gradient-to-r from-transparent to-[#d7a51f]" />
        <span className="text-[28px] leading-none text-[#d7a51f]">✦</span>
        <span className="h-[2px] flex-1 bg-gradient-to-l from-transparent to-[#d7a51f]" />
      </div>

      <h2 className="mt-5 text-center font-serif text-[28px] font-semibold normal-case tracking-normal text-[#111b3a] md:text-[36px] lg:text-[42px]">
       {branch.valuationProcessTitle || (
  <>
    Transparent Gold Valuation Process in <br className="hidden sm:block" />
  {branch.area || branch.city || "Bangalore"}
  </>
)}
      </h2>

      {/* 3 cards centered */}
      <div className="mx-auto mt-14 grid max-w-[1080px] grid-cols-1 justify-items-center gap-10 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
     {(branch.valuationProcessCards || [
  {
    number: "1",
    title: "Accurate Purity Testing",
    text: "We check your gold purity carefully to understand the correct quality of your gold items.",
    image: "/images/how-it-works/malleshwaram-purity-testing.png",
  },
  {
    number: "2",
    title: "Exact Gold Weight Checking",
    text: "Your gold is weighed accurately before valuation, so the final value is calculated with complete clarity.",
    image: "/images/how-it-works/malleshwaram-weight-checking.png",
  },
  {
    number: "3",
    title: "Live Gold Rate Pricing",
    text: "Your gold value is calculated using the current live gold rate, helping you get the fair price you deserve.",
    image: "/images/how-it-works/malleshwaram-live-rate.png",
  },
]).map((item, index) => (
          <div key={index} className="relative w-full max-w-[340px]">
            <div className="absolute left-1/2 top-[-28px] z-20 flex h-[58px] w-[58px] -translate-x-1/2 items-center justify-center rounded-full bg-gradient-to-br from-[#f6d65c] to-[#c79211] text-[24px] font-bold text-white shadow-[0_14px_28px_rgba(198,146,24,0.38)]">
              {item.number}
            </div>

            <div className="flex min-h-[360px] w-full flex-col items-center justify-start rounded-[22px] border border-[#ead8a8] bg-white px-7 pb-8 pt-14 text-center shadow-[0_18px_45px_rgba(20,33,61,0.06)] transition-all duration-300 hover:-translate-y-1 hover:border-[#d7a51f] hover:shadow-[0_24px_55px_rgba(198,146,24,0.13)]">
              <div className="flex h-[110px] w-[130px] items-center justify-center">
                <img
                  src={`${process.env.PUBLIC_URL}${item.image}`}
                  alt={item.title}
                  className="h-[105px] w-[120px] object-contain drop-shadow-[0_10px_18px_rgba(120,72,0,0.18)]"
                  loading="lazy"
                />
              </div>

              <h3 className="mt-4 text-[20px] font-bold leading-snug text-[#111b3a] md:text-[21px]">
                {item.title}
              </h3>

              <div className="mt-4 flex items-center justify-center gap-2">
                <span className="h-px w-10 bg-[#d7a51f]/70" />
                <span className="h-2 w-2 rotate-45 bg-[#d7a51f]" />
                <span className="h-px w-10 bg-[#d7a51f]/70" />
              </div>

              <p className="mt-5 text-[16px] font-medium leading-8 text-[#1f2937]">
                {item.text}
              </p>
            </div>

            {index < 2 && (
              <div className="pointer-events-none absolute right-[-34px] top-[45%] z-20 hidden -translate-y-1/2 text-[42px] font-bold text-[#d7a51f] lg:block">
                →
              </div>
            )}
          </div>
        ))}
      </div>

      {/* bottom trust bar */}
      <div className="mx-auto mt-10 w-fit max-w-full rounded-[22px] border border-[#ead8a8] bg-white px-5 py-3 shadow-[0_10px_28px_rgba(20,33,61,0.05)] sm:rounded-full">
        <div className="flex flex-col items-center justify-center gap-3 text-center sm:flex-row">
          <span className="flex h-[44px] w-[44px] shrink-0 items-center justify-center rounded-full bg-[#fff3cc] text-[#c79211] shadow-[inset_0_0_0_6px_rgba(255,255,255,0.70)]">
            <svg
              viewBox="0 0 24 24"
              className="h-6 w-6"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 3l7 3v5c0 4.5-2.8 8.5-7 10-4.2-1.5-7-5.5-7-10V6l7-3z" />
              <path d="M9 12l2 2 4-4" />
            </svg>
          </span>

       <p className="text-center text-[14px] font-semibold leading-6 text-[#111b3a] sm:text-[15px] md:text-[16px] lg:whitespace-nowrap">
  {`Transparent valuation explained before payment, helping you sell gold in ${
    branch.area || branch.city || "Bangalore"
  } confidently.`}
</p>
        </div>
      </div>
    </div>
  </section>
)}
{/* YELAHANKA ONLY - GOLD BUYERS SECTION */}
{isYelahankaPage && (
  <section className="relative overflow-hidden bg-[#fffaf0] py-8 sm:py-10 lg:py-12">
    <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-[#f4d16b]/20 blur-3xl" />
    <div className="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-[#c89b2b]/15 blur-3xl" />

    <div className="relative mx-auto max-w-[1280px] px-4 sm:px-6 lg:px-10">
      <div className="overflow-hidden rounded-[22px] border border-white/70 bg-white/55 shadow-[0_20px_60px_rgba(20,33,61,0.10)] backdrop-blur-xl sm:rounded-[28px] lg:rounded-[32px]">

        <div className="grid items-stretch lg:grid-cols-[0.9fr_1.1fr]">

          {/* LEFT IMAGE */}
          <div className="relative min-h-[240px] overflow-hidden sm:min-h-[320px] lg:min-h-[410px]">
            <img
              src="/images/branches/buyers-bangalore4.jpeg"
              alt="Gold buyers in Yelahanka"
              className="absolute inset-0 h-full w-full object-cover"
              loading="lazy"
            />

            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#07152b]/15 via-transparent to-transparent" />
          </div>

          {/* RIGHT CONTENT */}
          <div className="relative flex items-center bg-white/50 px-5 py-7 backdrop-blur-xl sm:px-8 sm:py-9 lg:px-10 lg:py-12">

            <div>
              <div className="mb-4 flex items-center gap-3">
                <span className="h-[2px] w-10 bg-[#c89b2b] sm:w-14" />
                <span className="h-2 w-2 rotate-45 bg-[#d7a51f]" />
              </div>

              <h2 className="text-[26px] font-bold leading-[1.2] tracking-[-0.02em] text-[#06152f] sm:text-[32px] lg:text-[38px]">
                Gold Buyers in Yelahanka to Sell Gold for Instant Cash
              </h2>

              <p className="mt-5 text-[14px] leading-7 text-[#334155] sm:text-[15px] sm:leading-8 md:text-[16px] lg:text-[17px] lg:leading-8">
                Looking for trusted{" "}
                <strong className="font-bold text-[#06152f]">
                  gold buyers in Yelahanka
                </strong>{" "}
                to sell your gold for instant cash? Get your gold checked for
                purity, verified for accurate weight, and valued using the
                applicable gold rate before you decide to sell. You can bring
                old gold jewellery, broken gold, chains, rings, bangles, coins,
                and unused ornaments for valuation. The complete calculation is
                explained clearly, so you know exactly how the final amount is
                determined. Once you accept the offer, the sale can be completed
                quickly with{" "}
                <strong className="font-bold text-[#06152f]">
                  instant payment
                </strong>
                , making it easier to convert your gold into cash without
                unnecessary delays.
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
)}
{!hideSections.process && (
  isBangalorePage ? (
  <section className="relative overflow-hidden bg-[#fffaf0] py-10 sm:py-12 lg:py-14">
    {/* soft corner patterns */}
    <div className="pointer-events-none absolute right-[-90px] top-[-90px] h-[260px] w-[260px] rounded-full border border-[#ead8a8]/70" />
    <div className="pointer-events-none absolute left-[-90px] bottom-[-90px] h-[260px] w-[260px] rounded-full border border-[#ead8a8]/70" />

    <div className="relative mx-auto max-w-[1220px] px-4 sm:px-6 lg:px-10">
      {/* Heading */}
      <div className="text-center">
        <p className="text-[12px] font-bold uppercase tracking-[0.42em] text-[#b68b22]">
    {branch.processEyebrow || "Simple Process"}
        </p>

        <div className="mx-auto mt-3 flex w-[145px] items-center justify-center gap-3">
          <span className="h-px flex-1 bg-[#d7a51f]" />
          <span className="h-2 w-2 rotate-45 bg-[#d7a51f]" />
          <span className="h-px flex-1 bg-[#d7a51f]" />
        </div>

      <h2 className="mt-5 font-serif text-[30px] font-bold leading-tight text-[#111b3a] sm:text-[40px] lg:text-[48px]">
  {branch.processTitle || "How It Works – Simple 5-Step Process"}
</h2>

        <div className="mx-auto mt-4 flex w-[145px] items-center justify-center gap-3">
          <span className="h-px flex-1 bg-[#d7a51f]" />
          <span className="h-2 w-2 rotate-45 bg-[#d7a51f]" />
          <span className="h-px flex-1 bg-[#d7a51f]" />
        </div>
      </div>

      {/* Timeline */}
      <div className="relative mx-auto mt-8 max-w-[900px] lg:mt-9">
        {/* mobile logo */}
        <div className="mx-auto mb-8 flex h-[76px] w-[76px] items-center justify-center rounded-full border-[6px] border-[#d7a51f] bg-white shadow-[0_12px_28px_rgba(198,146,24,0.22)] lg:hidden">
          <div className="text-center leading-none">
            <p className="text-[23px] font-extrabold text-[#111b3a]">G1</p>
            <p className="text-[10px] font-bold text-[#b68b22]">GOLD</p>
          </div>
        </div>

        {/* desktop center line */}
        <div className="absolute left-1/2 top-[68px] bottom-[22px] hidden w-px -translate-x-1/2 bg-[#d7a51f] lg:block" />

        {/* desktop logo */}
        <div className="absolute left-1/2 top-0 z-30 hidden h-[66px] w-[66px] -translate-x-1/2 items-center justify-center rounded-full border-[5px] border-[#d7a51f] bg-white shadow-[0_10px_24px_rgba(198,146,24,0.22)] lg:flex">
          <div className="text-center leading-none">
<p className="text-[21px] font-extrabold text-[#111b3a]">G1</p>
<p className="text-[9px] font-bold text-[#b68b22]">GOLD</p>
          </div>
        </div>

       <div className="relative space-y-8 sm:space-y-4 lg:space-y-5 lg:pt-[58px]">
     {(
  branch.processSteps || [
    "Find the nearest G1 Gold branch in Bangalore",
    "Carry valid ID proof such as Aadhaar, Driving Licence, Passport, or PAN Card",
    "Get accurate purity testing by experts",
    "Receive the final value based on purity, weight, and current gold rate",
    "Get payment through the available payment method",
  ]
)
  .slice(0, 5)
  .map((step, index) => {
    const item = {
      number: String(index + 1),
      text: step,
      icon: processIcons[index] || processIcons[0],
    };

    const isLeft = index % 2 === 0;

            const card = (
              <div
              className={`relative w-full max-w-[360px] rounded-[16px] border border-[#ead8a8] bg-white px-4 pb-4 pt-10 shadow-[0_12px_30px_rgba(20,33,61,0.06)] transition-all duration-300 hover:-translate-y-1 hover:border-[#d7a51f] hover:shadow-[0_18px_42px_rgba(198,146,24,0.12)] sm:px-5 sm:py-4 ${
  isLeft
    ? "lg:mr-8 lg:justify-self-end"
    : "lg:ml-8 lg:justify-self-start"
}`}
              >
                {/* number circle */}
                <div
  className={`absolute -top-4 left-1/2 z-20 flex h-10 w-10 -translate-x-1/2 items-center justify-center rounded-full bg-gradient-to-br from-[#f6d65c] to-[#c79211] text-[18px] font-bold text-white shadow-[0_10px_22px_rgba(198,146,24,0.36)] lg:translate-x-0 ${
    isLeft
      ? "lg:left-[-16px]"
      : "lg:left-auto lg:right-[-16px]"
  }`}
>
  {item.number}
</div>

                <div className="flex flex-col items-center gap-4 pt-1 text-center sm:flex-row sm:gap-3 sm:pt-2 sm:text-left">
                  <div className="flex h-[60px] w-[60px] shrink-0 items-center justify-center rounded-full border border-[#ead8a8] bg-[#fff8df] text-[#c79211] shadow-[inset_0_0_0_6px_rgba(255,255,255,0.65)] [&>svg]:h-8 [&>svg]:w-8">
                    {item.icon}
                  </div>

                  <div className="hidden h-10 w-px bg-[#ead8a8] sm:block" />

                  <p className="text-[13px] font-semibold leading-5 text-[#111b3a] sm:text-[14px] md:text-[15px]">
                    {item.text}
                  </p>
                </div>
              </div>
            );

            return (
              <div
                key={index}
                className="relative grid items-center gap-3 lg:grid-cols-[1fr_78px_1fr]"
              >
                {isLeft ? card : <div className="hidden lg:block" />}

                {/* center connector */}
                <div className="relative hidden h-full items-center justify-center lg:flex">
                  <span className="z-20 h-[14px] w-[14px] rounded-full border-2 border-[#d7a51f] bg-[#fffaf0]" />
                  <span
                    className={`absolute top-1/2 h-px w-[48px] -translate-y-1/2 bg-[#d7a51f] ${
                      isLeft ? "right-[48px]" : "left-[48px]"
                    }`}
                  />
                </div>

                {!isLeft ? card : <div className="hidden lg:block" />}
              </div>
            );
          })}
        </div>

        {/* bottom diamond */}
        <div className="mx-auto mt-7 hidden h-3 w-3 rotate-45 bg-[#d7a51f] lg:block" />
      </div>
    </div>
  </section>
) : (
  <section className="relative overflow-hidden bg-[#fffaf0] py-16 lg:py-24">
    <div className="relative mx-auto max-w-[1280px] px-5 sm:px-6 lg:px-14">
      <div className="grid items-center gap-14 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20">
        
        {/* LEFT CONTENT */}
        <div className="text-center lg:text-left">
          <p className="text-[12px] font-bold uppercase tracking-[0.36em] text-[#b68b22]">
        {branch.processEyebrow || "Simple Process"}
          </p>

          <div className="mx-auto mt-3 flex w-[160px] items-center justify-center gap-3 lg:mx-0">
            <span className="h-[1px] flex-1 bg-[#d7a51f]" />
            <span className="h-2 w-2 rotate-45 bg-[#d7a51f]" />
            <span className="h-[1px] flex-1 bg-[#d7a51f]" />
          </div>

          <h2 className="mt-8 max-w-[560px] text-[34px] font-extrabold leading-[1.16] tracking-[-0.04em] text-[#06152f] sm:text-[42px] md:text-[48px] lg:text-[52px]">
            {branch.processTitle || "How It Works  Simple 5-Step Process"}
          </h2>

          <div className="mx-auto mt-7 h-[2px] w-[55px] bg-[#d7a51f] lg:mx-0" />

     <p className="mx-auto mt-7 max-w-[520px] text-[16px] font-medium leading-8 text-[#4b5563] sm:text-[17px] lg:mx-0">
  {branch.processDescription ||
    "Transparent 5-step process to sell gold safely and get instant payment."}
</p>
        </div>

        {/* RIGHT TIMELINE */}
        <div className="relative mx-auto w-full max-w-[640px]">
          <div className="relative pl-0 sm:pl-[74px]">
            
            {/* vertical gold line */}
            <div className="absolute left-[18px] top-[41px] bottom-[70px] hidden w-[2px] bg-[#d7a51f] sm:block" />

            <div className="space-y-7">
              {branch.processSteps?.slice(0, 5).map((step, index) => (
                <div
                  key={index}
                  className="relative grid grid-cols-1 gap-4 border-b border-[#d7a51f]/55 pb-7 last:border-b-0 sm:grid-cols-[88px_1fr] sm:gap-7"
                >
                  {/* dot on vertical line */}
                  <span className="absolute left-[-61px] top-[34px] z-20 hidden h-[14px] w-[14px] rounded-full border-2 border-[#d7a51f] bg-[#fffaf0] sm:block" />

                  {/* icon circle */}
                  <div className="flex justify-center sm:justify-start">
                    <div className="flex h-[84px] w-[84px] items-center justify-center rounded-full border border-[#d7a51f] bg-[#fffaf0] text-[#c19122] shadow-[0_10px_24px_rgba(198,146,24,0.06)] [&>svg]:h-10 [&>svg]:w-10">
                      {processIcons[index] || processIcons[0]}
                    </div>
                  </div>

                  {/* text */}
                  <div className="flex min-h-[84px] items-center text-center sm:text-left">
                    <p className="text-[17px] font-semibold leading-8 text-[#06152f] sm:text-[18px] md:text-[19px]">
                      {step}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </div>
    </section>
  )
)}

{/* BANGALORE ONLY - VALUE FIRST REFERENCE STYLE SECTION */}
{/* BANGALORE ONLY - VALUE FIRST REFERENCE STYLE SECTION */}
{isBangalorePage && (
<section className="relative overflow-hidden bg-[#fffaf0] py-8 sm:py-10 lg:py-12">
    <div className="relative mx-auto max-w-[1380px] px-4 sm:px-6 lg:px-8">
      <div className="relative overflow-hidden rounded-[22px] border border-[#d7a51f] bg-[#fffdf7] px-5 py-6 shadow-[0_16px_45px_rgba(20,33,61,0.06)] sm:px-6 sm:py-7 lg:px-8 lg:py-8">
        
        {/* Soft Background */}
        <div className="pointer-events-none absolute left-[-140px] top-[-140px] h-[340px] w-[340px] rounded-full bg-[#f4d16b]/14 blur-3xl" />
        <div className="pointer-events-none absolute right-[-150px] bottom-[-150px] h-[360px] w-[360px] rounded-full bg-[#c89b2b]/10 blur-3xl" />

        <div className="relative grid items-center gap-6 lg:grid-cols-[0.9fr_1.1fr] lg:gap-8">
          
          {/* LEFT CONTENT */}
          <div className="flex flex-col justify-center">
            <div className="mb-4 flex w-[135px] items-center gap-3">
              <span className="h-[2px] flex-1 bg-[#c89b2b]" />
              <span className="h-2.5 w-2.5 rotate-45 bg-[#c89b2b]" />
            </div>

          <h2 className="max-w-[650px] text-[28px] font-bold leading-[1.25] tracking-[-0.01em] text-[#06152f] sm:text-[34px] lg:text-[42px]">
  {branch.valueFirstTitle ||
    "Sell Gold in Bangalore After Knowing What Your Gold Is Worth"}
</h2>

          <div className="mt-5 max-w-[680px] space-y-4 text-[14px] font-normal leading-7 text-[#334155] sm:text-[15px] sm:leading-7">
  <p
    dangerouslySetInnerHTML={{
      __html:
        branch.valueFirstDescription1 ||
        "If you are planning to sell gold in Bangalore, G1 Gold evaluates your jewellery by checking its purity, net gold weight, current gold rate, stone weight, and any applicable deductions. You can bring old chains, bangles, rings, earrings, coins, broken ornaments, or stone-studded jewellery for evaluation. The factors that influence your gold's value are explained clearly, helping you understand how the final offer is determined. ",
    }}
  />

  <p
    dangerouslySetInnerHTML={{
      __html:
        branch.valueFirstDescription2 ||
        "At G1 Gold, you can review the quoted value before making your decision. The sale proceeds only after you are satisfied with the offer and give your approval. Once confirmed, the payment is processed quickly. If you are looking to sell gold for cash in Bangalore, the process helps you understand the value of your jewellery before you complete the transaction. ",
    }}
  />
</div>
          </div>

          {/* RIGHT IMAGE */}
         <div className="relative h-[280px] overflow-hidden rounded-[18px] bg-white shadow-[0_14px_35px_rgba(20,33,61,0.08)] sm:h-[340px] lg:h-[420px]">
            <img
              src={branch.valueFirstImage || branch.mainImage}
              alt={branch.valueFirstImageAlt || branch.mainImageAlt || "Sell Gold Bangalore"}
          className="h-full w-full object-cover object-[center_28%]"
              loading="lazy"
            />
          </div>

        </div>
      </div>
    </div>
  </section>
)}
{/* WHY CHOOSE US */}
{!hideSections.whyChoose && (
<section className="relative overflow-hidden bg-[#06152f] py-16 lg:py-20">
  {/* Background effects */}
  <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(244,209,107,0.10),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(200,155,43,0.10),transparent_34%)]" />

  <div className="absolute left-[-220px] top-[-230px] h-[560px] w-[560px] rounded-full border border-[#f4d16b]/10" />
  <div className="absolute right-[-250px] bottom-[-260px] h-[620px] w-[620px] rounded-full border border-[#f4d16b]/15" />

  <div className="absolute right-16 top-10 hidden h-28 w-28 bg-[radial-gradient(circle,rgba(244,209,107,0.35)_1px,transparent_1px)] [background-size:12px_12px] opacity-30 lg:block" />
  <div className="absolute left-16 bottom-14 hidden h-28 w-28 bg-[radial-gradient(circle,rgba(244,209,107,0.35)_1px,transparent_1px)] [background-size:12px_12px] opacity-30 lg:block" />

  <div className="relative mx-auto max-w-[1250px] px-6">
    <div className="mx-auto max-w-4xl text-center">
      <div className="flex items-center justify-center gap-4">
        <span className="h-[1px] w-12 bg-[#c89b2b]" />
        <p className="text-[11px] font-semibold uppercase tracking-[0.32em] text-[#f4d16b]">
          Why Choose Us
        </p>
        <span className="h-[1px] w-12 bg-[#c89b2b]" />
      </div>

      <h2 className="mt-4 text-[32px] font-semibold leading-tight text-white md:text-[40px] lg:text-[46px]">
        {branch.whyChooseTitle}
      </h2>
    </div>

    <div className="mx-auto mt-12 grid max-w-[1080px] gap-6 md:grid-cols-2">
      {branch.whyChooseItems?.slice(0, 4).map((item, index) => (
       <div
  key={index}
  className="group relative min-h-[142px] overflow-hidden rounded-[24px] border border-[#c89b2b]/35 bg-[#0d1f3b]/85 px-7 py-7 shadow-[0_18px_45px_rgba(0,0,0,0.28)] transition-all duration-300 hover:-translate-y-1 hover:border-[#f4d16b]/60 hover:bg-[#10274a]"
>
  <div className="absolute inset-0 bg-gradient-to-br from-white/[0.04] via-transparent to-transparent" />

  <div className="absolute right-6 top-1/2 flex h-24 w-24 -translate-y-1/2 items-center justify-center opacity-95">
    {[
    
      <img
      src={ratesIcon}
  
        alt="Advanced Gold Testing"
        className="h-20 w-20 object-contain"
      />,

      <img
      src={paymentIcon}
        
        alt="Instant Payment"
        className="h-16 w-16 object-contain"
      />,

      <img

     src={trustIcon}
        alt="Live Market Rates"
        className="h-20 w-20 object-contain"
      />,

      <img
       src={testingIcon}
   
        alt="Trusted Gold Buyers"
        className="h-16 w-16 object-contain"
      />,
    ][index]}
  </div>

  <div className="relative flex items-start gap-5">
    <div
      className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl text-sm font-semibold text-[#081225] shadow-[0_12px_25px_rgba(244,209,107,0.28)]"
      style={{
        background: "linear-gradient(135deg, #F8D86A 0%, #D7A51F 100%)",
      }}
    >
      {index + 1}
    </div>

    <div className="pr-16">
      <h3 className="text-[18px] font-semibold leading-snug text-white">
        {item.title}
      </h3>

    <p className="mt-3 text-[15px] leading-7 text-white/75">
  {item.description.split(/\n|\\n/).map((line, i) => (
    <span key={i}>
      {line}
      {i !== item.description.split(/\n|\\n/).length - 1 && <br />}
    </span>
  ))}
</p>
    </div>
  </div>
</div>
      ))}
    </div>
  </div>
</section>
)}

{/* G1 Gold Advantage Comparison */}
{!hideSections.advantage && (
<section className="relative overflow-hidden bg-[#fffaf0] py-16 lg:py-20">
  {/* Soft background glow */}
  <div className="absolute left-[-120px] top-[-120px] h-72 w-72 rounded-full bg-[#f4d16b]/20 blur-3xl" />
  <div className="absolute right-[-140px] bottom-[-140px] h-80 w-80 rounded-full bg-[#c89b2b]/15 blur-3xl" />

  <div className="relative mx-auto max-w-[1450px] px-6 lg:px-14">
    {/* Heading */}
    <div className="mx-auto max-w-5xl text-center">
      <p className="inline-flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.32em] text-[#b68b22]">
        <span>♛</span>
        {advantageContent.eyebrow}
      </p>

      <h2 className="mt-4 font-serif text-[34px] font-bold leading-tight text-[#111827] md:text-[46px] lg:text-[56px]">
        {advantageContent.title}
      </h2>

      <div className="mx-auto mt-4 flex w-40 items-center justify-center gap-3">
        <span className="h-[1px] flex-1 bg-[#d7a51f]/70" />
        <span className="h-2 w-2 rotate-45 bg-[#d7a51f]" />
        <span className="h-[1px] flex-1 bg-[#d7a51f]/70" />
      </div>

 <p
  className="mx-auto mt-5 max-w-3xl text-[16px] leading-8 text-[#4b5563] md:text-[18px]"
  dangerouslySetInnerHTML={{ __html: advantageContent.description }}
/>
    </div>
<p className="mt-6 text-center text-[12px] font-semibold text-[#b68b22] lg:hidden">
  Swipe left to see full comparison →
</p>
<style>
  {`
    @media (max-width: 1023px) {
      .bangalore-advantage-scroll {
        width: calc(100vw - 0px);
        max-width: 100vw;
        overflow-x: auto !important;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
touch-action: auto;
        scrollbar-width: thin;
        scrollbar-color: #c88908 #fff3c4;
      }

      .bangalore-advantage-scroll::-webkit-scrollbar {
        height: 10px;
        display: block;
      }

      .bangalore-advantage-scroll::-webkit-scrollbar-track {
        background: #fff3c4;
        border-radius: 999px;
      }

      .bangalore-advantage-scroll::-webkit-scrollbar-thumb {
        background: linear-gradient(90deg, #c88908, #dfaa1c);
        border-radius: 999px;
      }

      .bangalore-advantage-table {
        width: 820px;
        min-width: 820px;
      }
    }
  `}
</style>
    {/* Table - Mobile Horizontal Scroll */}
    <div className="bangalore-advantage-scroll -mx-6 mt-10 px-5 pb-8 lg:mx-0 lg:mt-12 lg:px-0 lg:overflow-visible">
  <div className="bangalore-advantage-table overflow-hidden rounded-[22px] border border-[#ead8a8] bg-white shadow-[0_24px_70px_rgba(20,33,61,0.10)] lg:w-full lg:min-w-0 lg:rounded-[28px]">
<div className="grid grid-cols-[240px_280px_300px] lg:grid-cols-3">        
          <div className="border-b border-r border-[#ead8a8] bg-white px-6 py-5 text-center">
            <h3 className="text-[16px] font-bold leading-6 text-[#111827] lg:text-[18px]">
              {advantageContent.leftHeader}
            </h3>
          </div>

          <div className="border-b border-r border-[#ead8a8] bg-[#f8f8f8] px-6 py-5 text-center">
            <h3 className="text-[16px] font-bold leading-6 text-[#374151] lg:text-[18px]">
              {advantageContent.middleHeader}
            </h3>
          </div>

          <div className="border-b border-[#d7a51f]/40 bg-gradient-to-r from-[#c88908] to-[#dfaa1c] px-6 py-5 text-center">
            <h3 className="text-[16px] font-bold leading-6 text-white lg:text-[18px]">
              {advantageContent.rightHeader}
            </h3>
          </div>
        </div>

        {/* Rows */}
        {advantageContent.rows.map((row, index) => (
          <div
            key={index}
          className="grid grid-cols-[240px_280px_300px] border-b border-[#ead8a8]/70 last:border-b-0 lg:grid-cols-3"
          >
            {/* Customer Want */}
            <div className="flex items-center gap-5 border-r border-[#ead8a8]/70 px-6 py-6">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-[#f1d98b] bg-[#fff8df] text-[#c69218]">
                <svg
                  viewBox="0 0 24 24"
                  className="h-6 w-6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.9"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  {advantageIcons[index] || advantageIcons[0]}
                </svg>
              </div>

              <p className="text-[15px] font-bold leading-6 text-[#1f2937] lg:text-[17px]">
                {row.want}
              </p>
            </div>

            {/* Other Buyers */}
            <div className="flex items-center gap-4 border-r border-[#ead8a8]/70 bg-[#fafafa] px-6 py-6">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#e5e7eb] text-[#8b8b8b]">
                <svg
                  viewBox="0 0 24 24"
                  className="h-4 w-4"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="round"
                >
                  <path d="M6 6l12 12" />
                  <path d="M18 6L6 18" />
                </svg>
              </div>

              <p className="text-[14px] font-medium leading-6 text-[#4b5563] lg:text-[15px]">
                {row.other}
              </p>
            </div>

            {/* G1 Promise */}
            <div className="flex items-center gap-4 bg-[#fff9e8] px-6 py-6">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#2fb344] text-white shadow-[0_8px_18px_rgba(47,179,68,0.25)]">
                <svg
                  viewBox="0 0 24 24"
                  className="h-4 w-4"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 6L9 17l-5-5" />
                </svg>
              </div>

              <p className="text-[14px] font-medium leading-6 text-[#111827] lg:text-[16px]">
                {row.promise}
              </p>
            </div>
          </div>
        ))}

      </div>
    </div>
  </div>
</section>

)}
{/* BANGALORE ONLY - GOLD BUYERS COMPACT SECTION */}
{isBangalorePage && (
  <section className="relative w-full overflow-hidden bg-[#fffaf0] py-6 sm:py-8 lg:py-10">
    <div className="relative w-full px-4 sm:px-6 lg:px-8">
      <div className="relative w-full overflow-hidden rounded-[22px] border border-[#d7a51f]/45 bg-white/70 px-5 py-6 shadow-[0_16px_45px_rgba(20,33,61,0.06)] backdrop-blur-md sm:px-6 sm:py-7 lg:px-8 lg:py-8">
        
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/70 via-white/35 to-[#fff4cf]/25" />

        <div className="relative grid items-center gap-6 lg:grid-cols-[0.85fr_1.15fr] lg:gap-8">
          
          {/* LEFT TITLE + IMAGE */}
          <div>
            <div className="mb-4 flex w-[110px] items-center gap-3">
              <span className="h-[2px] flex-1 bg-[#c89b2b]" />
              <span className="h-2.5 w-2.5 rotate-45 bg-[#c89b2b]" />
            </div>

            <h2 className="max-w-[520px] text-[26px] font-bold leading-[1.18] tracking-[-0.02em] text-[#06152f] sm:text-[32px] lg:text-[38px]">
  {branch.gramExplainTitle ||
    "Sell Gold in Bangalore for Live Gold Valuation and Quick Payment"}
</h2>

            <div className="mt-5 overflow-hidden rounded-[18px] border border-[#ead8a8] bg-white shadow-[0_14px_35px_rgba(20,33,61,0.08)]">
              <img
                src={branch.gramExplainImage || branch.mainImage}
                alt={branch.gramExplainImageAlt || branch.mainImageAlt || "Gold Buyers Bangalore"}
               className="h-[240px] w-full object-cover object-top sm:h-[300px] lg:h-[350px]"
                loading="lazy"
              />
            </div>
          </div>

{/* RIGHT CONTENT */}
<div className="relative lg:ml-6 xl:ml-10">
  <div className="hidden lg:absolute lg:left-[-24px] lg:top-0 lg:block lg:h-full lg:w-px lg:bg-gradient-to-b lg:from-transparent lg:via-[#d7a51f]/55 lg:to-transparent" />
<div className="space-y-6 px-2 sm:px-3 lg:px-6">
  <p
    className="text-[15px] font-normal leading-8 text-[#334155] sm:text-[16px] lg:text-[17px] lg:leading-9"
    dangerouslySetInnerHTML={{
      __html:
        branch.gramExplainDescription1 ||
        "If you are looking to <a href=\"https://g1gold.com/\"><strong>sell gold in Bangalore</strong></a>  G1 Gold evaluates each item using its purity, net gold weight, current gold rate, stone weight, and other non-gold components. You can bring old chains, bangles, rings, earrings, coins, broken jewellery, or stone-studded ornaments for evaluation. The valuation is explained before you make a decision, including the gold weight considered for pricing and how the final payable amount is calculated. ",
    }}
  />

  <p
    className="text-[15px] font-normal leading-8 text-[#334155] sm:text-[16px] lg:text-[17px] lg:leading-9"
    dangerouslySetInnerHTML={{
      __html:
        branch.gramExplainDescription2 ||
        "You can review the offer before agreeing to sell your gold. G1 Gold proceeds with the transaction only after your approval, so you know the value being offered before handing over your jewellery. Once the offer is accepted, payment is processed quickly. For customers searching for sell gold in Bangalore services with clear valuation and a straightforward selling process, G1 Gold provides a direct way to check the value of gold and complete the sale.",
    }}
  />
</div>
</div>

        </div>
      </div>
    </div>
  </section>
)}
{/* Malleshwaram Location Section */}
{/* Malleshwaram Location Section */}
{isMalleshwaramPage && (
<section className="relative overflow-hidden bg-[#fffaf0] py-10 lg:py-12">
    {/* dark premium background */}
    

  <div className="relative mx-auto max-w-[1280px] px-5 sm:px-6 lg:px-8">
<div className="overflow-hidden rounded-[18px] border border-[#ead8a8] bg-[#fffdf8] px-5 py-5 shadow-[0_18px_45px_rgba(20,33,61,0.08)] lg:px-6 lg:py-6">
<div className="grid grid-cols-1 gap-6 lg:grid-cols-[1fr_0.95fr] lg:items-stretch">
          {/* Left map image */}
<div className="group relative min-w-0 overflow-hidden rounded-[24px] border border-[#d7a51f]/70 bg-gradient-to-br from-[#fff3c4] via-white to-[#fffaf0] p-[5px] shadow-[0_18px_45px_rgba(20,33,61,0.12)] lg:h-[500px]">
  {/* map frame */}
<div className="relative h-[330px] overflow-hidden rounded-[20px] bg-white sm:h-[360px] lg:h-full">
    <iframe
      title="G1 Gold Malleshwaram Location Map"
      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d242.9681039150621!2d77.5709046!3d13.0044598!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae17f210b0efa3%3A0x196bf2b6e8af548d!2sG-One%20Gold%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1780900448410!5m2!1sen!2sin"
      className="absolute inset-0 h-full w-full border-0"
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      allowFullScreen
    />

    <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/10 via-transparent to-[#06152f]/10" />
  </div>
</div>

          {/* Right location content */}
  <div className="min-w-0 flex h-full flex-col justify-start lg:h-[500px]">
            {/* heading */}
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center gap-4">
                <span className="h-px w-20 bg-[#d7a51f]" />
                <p className="text-[13px] font-bold uppercase tracking-[0.24em] text-[#b98512]">
                  Our Location
                </p>
                <span className="h-px w-20 bg-[#d7a51f]" />
              </div>

            <h2 className="mt-3 font-serif text-[28px] font-bold leading-tight text-[#111b3a] md:text-[34px] lg:text-[38px]">
  Visit G1 Gold Malleshwaram
</h2>
            </div>

            {/* contact card */}
           <div className="mt-5 flex flex-1 flex-col justify-center rounded-[18px] border border-[#ead8a8] bg-white px-6 py-5 shadow-[0_14px_35px_rgba(20,33,61,0.08)]">
              <div className="space-y-5">
                {/* address */}
                <div className="flex items-start gap-5">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-[#ead8a8] bg-[#fff8df] text-[#c79211]">
                    <svg
                      viewBox="0 0 24 24"
                      className="h-6 w-6"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 21s-6-5.2-6-10a6 6 0 1 1 12 0c0 4.8-6 10-6 10z" />
                      <circle cx="12" cy="11" r="2.5" />
                    </svg>
                  </span>

                  <div>
              <h3 className="font-serif text-[22px] font-bold leading-tight text-[#111b3a]">
                      G1 Gold
                    </h3>
          <p className="mt-2 text-[15px] font-medium leading-7 text-[#34405a]">

                      1st Floor, Satya Sai Complex,
No. 224, 14th Cross,<br/>
Sampige Road, Malleswaram,
Bengaluru, Karnataka 
                    </p>
                  </div>
                </div>

                <div className="h-px w-full bg-[#ead8a8]" />

                {/* phone */}
                <div className="flex items-center gap-5">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-[#ead8a8] bg-[#fff8df] text-[#c79211]">
                    <svg
                      viewBox="0 0 24 24"
                      className="h-5 w-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.8 19.8 0 0 1 3.08 5.18 2 2 0 0 1 5.06 3h3a2 2 0 0 1 2 1.72c.12.9.33 1.77.63 2.6a2 2 0 0 1-.45 2.11L9 10.7a16 16 0 0 0 4.3 4.3l1.27-1.24a2 2 0 0 1 2.11-.45c.83.3 1.7.51 2.6.63A2 2 0 0 1 22 16.92z" />
                    </svg>
                  </span>

             <p className="text-[13px] font-semibold text-[#111b3a]">
                +91 7996 800 900
                  </p>
                </div>

                <div className="h-px w-full bg-[#ead8a8]" />

                {/* timing */}
                <div className="flex items-center gap-5">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-[#ead8a8] bg-[#fff8df] text-[#c79211]">
                    <svg
                      viewBox="0 0 24 24"
                      className="h-5 w-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle cx="12" cy="12" r="8" />
                      <path d="M12 8v5l3 2" />
                    </svg>
                  </span>

                <p className="text-[13px] font-semibold text-[#111b3a]">
                    Mon - Sat: 9:30 AM - 6:30 PM
                  </p>
                </div>

                {/* buttons */}
                <div className="grid gap-5 pt-3 sm:grid-cols-2">
                  <a
                    href="tel:+918123846715"
                    className="inline-flex min-h-[48px] items-center justify-center gap-3 rounded-[12px] bg-gradient-to-r from-[#c88908] to-[#dfaa1c] px-6 py-3 text-[17px] font-bold text-white shadow-[0_14px_30px_rgba(198,146,24,0.30)] transition hover:-translate-y-0.5"
                  >
                    <span>☎</span>
                    Call Now
                  </a>

                  <a
                   href={malleshwaramMapLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex min-h-[48px] items-center justify-center gap-3 rounded-[12px] border border-[#111b3a]/45 bg-white px-6 py-3 text-[17px] font-bold text-[#111b3a] transition hover:-translate-y-0.5 hover:border-[#d7a51f]"
                  >
                    <span>◆</span>
                    Get Directions
                  </a>
                </div>
              </div>
            </div>

            
          </div>
        </div>

        {/* bottom ornament line */}
        <div className="mt-8 flex items-center justify-center gap-3">
          <span className="h-px flex-1 bg-[#d7a51f]/55" />
          <span className="h-4 w-4 rotate-45 bg-[#d7a51f]" />
          <span className="h-px flex-1 bg-[#d7a51f]/55" />
        </div>
      </div>
    </div>
  </section>
)}


{isRajajinagarPage && <RajajinagarContentSections />}
{/* GOLD VALUE CTA - SHOW ON ALL LANDING PAGES */}
<section className="relative overflow-hidden bg-[#fffaf0] py-8">
  <div className="mx-auto max-w-[1120px] px-5 sm:px-6 lg:px-10">
    <div className="relative overflow-hidden rounded-[20px] border border-[#ead8a8] bg-[#fffdf7] px-5 py-5 shadow-[0_18px_45px_rgba(20,33,61,0.06)] sm:px-7">
      <div className="pointer-events-none absolute right-4 top-3 text-[#d7a51f]">
        ✦
      </div>

      <div className="flex flex-col items-center gap-5 text-center lg:flex-row lg:text-left">
        <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full border border-[#ead8a8] bg-[#fff8df] text-[#c79211] shadow-[inset_0_0_0_6px_rgba(255,255,255,0.75)]">
          <span className="text-[22px]">♕</span>
        </div>

        <div className="flex-1">
          <h3 className="text-[24px] font-extrabold leading-tight text-[#06152f] sm:text-[28px]">
            Want to know your gold value today?
          </h3>
<p className="mt-2 text-[14px] font-medium leading-6 text-[#334155] sm:text-[15px]">
  Sell gold in {branch.area || branch.city || "Bangalore"} with confidence.
  <br />
  <a
    href="https://g1gold.com/"
    className="font-bold text-inherit no-underline"
  >
    Visit G1 Gold
  </a>{" "}
  today for clear valuation and quick payment.
</p>
        </div>

        <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
          <button
            type="button"
            onClick={scrollToGoldValueContact}
            className="inline-flex min-h-[44px] items-center justify-center rounded-[8px] bg-[#06152f] px-6 text-[14px] font-bold text-white shadow-[0_12px_24px_rgba(6,21,47,0.18)] transition hover:-translate-y-0.5"
          >
            ☎ Call Now
          </button>

          <a
            href={goldValueCtaDirectionsLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex min-h-[44px] items-center justify-center rounded-[8px] bg-[#d7a51f] px-6 text-[14px] font-bold text-white shadow-[0_12px_24px_rgba(215,165,31,0.24)] transition hover:-translate-y-0.5"
          >
            📍 Get Directions
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

       <ReusableLandingSections
  branch={branch}
  locationText={goldValueCtaLocationText}
  mapLink={goldValueCtaDirectionsLink}
/>
      </main>

  
   <Footer showCta />
    </div>
  );
};

export default BranchDetailPage;